module.exports = __webpack_public_path__ + "assets/public/imgs/network-policy-samples/2-limit-certain-apps.svg";